export const STORAGE_KEY_COMPANY = 'company-configuration';
export const STORAGE_KEY_RESOURCE_IDENTITY_TYPES = 'resource-identity-types';
export const STORAGE_KEY_RESOURCE_MED_SPECIALIZATIONS = 'resource-med-specializations';
export const STORAGE_KEY_RESOURCE_MED_TITLES = 'resource-med-titles';
export const STORAGE_KEY_TENANT = 'tenant';
export const STORAGE_BODY_AREAS = 'resource-body-areas';
export const STORAGE_KEY_NHF_CODE_ADDITIONAL_CITERIAL = 'resource-nhf-code-additional-citerial';
